import { NavigationGuardNext, RouteLocationNormalized } from 'vue-router'

export const equipmentBeforeEnter = async (
  _to: RouteLocationNormalized,
  _from: RouteLocationNormalized,
  next: NavigationGuardNext,
): Promise<void> => {
  const { useEquipmentStore } = await import('@/entities/equipment')
  const { fetchAll } = useEquipmentStore()
  await fetchAll()
  next()
}
